import {
  CONFIG_PUBLIC_DATA,
  GET_PROTOTYPE_PREVIEWS_API,
  GET_LABEL_OPTIONS_PUBLIC_API,
  GET_SCENE_LABEL_PUBLIC_API,
  API_ROOT_URL,
  GET_SCENE_PUBLIC_DATA,
  GET_SCENE_VIEW_BG_INFO_PUBLIC_API
} from '../constants/apiConstantV2'; 
import axios from 'axios';

export async function getAllPublicDataV2({ newModelIds, isOpenedFromAdminPanel, isRender = false }) {
    let url = API_ROOT_URL + '/' + CONFIG_PUBLIC_DATA + '?token=' + newModelIds;
    if (isOpenedFromAdminPanel) {
        url += `&is_render=${isRender}`;
    }
    const result = await axios.get(`${url}`);
    return result.data;
}

export async function getAllPublicDataPrototype({ configuratorId, isRender }) {
    const url = `${API_ROOT_URL}/${CONFIG_PUBLIC_DATA}${configuratorId}/?is_render=${isRender}`;
    const result = await axios.get(`${url}`);
    return result.data;
}

export async function getLabelsDataInPrototypeV2({ token, storeId, sceneId, isPublic = false }) {
  const url = `${API_ROOT_URL}${GET_SCENE_LABEL_PUBLIC_API}?token=${token}&store_id=${storeId}&scene_id=${sceneId}&is_public=${isPublic}`;
  const result = await axios.get(`${url}`);
  return result?.data?.results || [];
}

export async function getOptionsDataInPrototypeV2({ token, storeId, optionId, isPublic = false, page , sort = 'name' }) {
  const url = `${API_ROOT_URL}${GET_LABEL_OPTIONS_PUBLIC_API}?token=${token}&store_id=${storeId}&sceneoption_id=${optionId}&is_public=${isPublic}&page=${page}&per_page=${120}`;
  const result = await axios.get(`${url}`);
  return result?.data?.results || [];
}

export async function getTexturePreviewInPrototype({ storeId, textureId }) {
    const url = `${API_ROOT_URL}/${GET_PROTOTYPE_PREVIEWS_API}?store=${storeId}&texture=${textureId}`;
    const result = await axios.get(`${url}`);
    return result?.results || [];
}

export async function getSceneViewBackgroundInfoPublic({ storeId, token , scene }) {
  const url = `${API_ROOT_URL}${GET_SCENE_VIEW_BG_INFO_PUBLIC_API}?store=${storeId}&token=${token}&scene=${scene}`;
  const result = await axios.get(`${url}`);
  return result?.results || result?.data?.results || [];
}

export async function updateTexturePreviewInPrototype({ id, payload }) {
    const url = `${API_ROOT_URL}/${GET_PROTOTYPE_PREVIEWS_API}${id}/`;
    const result = await axios.patch(`${url}`, payload);
    return result || {};
}

export async function getScenesInPrototypeForPublic({ token, is_render = false }) {
  const url = `${API_ROOT_URL}/${GET_SCENE_PUBLIC_DATA}?token=${token}&is_render=${is_render}`;
  const result = await axios.get(`${url}`);
  return result?.data?.results || [];
}
